
import { useRoute, useRouter } from "vue-router";
import { defineComponent, inject, onMounted, ref, watchEffect } from "vue";
import { PREFECTURE_LIST } from "@/commons/constants";
import { ImageItem, ImageItemKey } from "@/modules/imageInfo";
import { Form, Field } from "vee-validate";
import { checkAddressNotReqd, checkBirthdayIsReqd, checkBloodTypeNotReqd, checkBuildingNotReqd, checkFirstKanaNotReqd, checkFirstNameNotReqd, checkGenderIsReqd, checkHasChildNotReqd, checkIsMarriedNotReqd, checkLastKanaNotReqd, checkLastNameNotReqd, checkNicknameIsReqd, checkPrefectureIsReqd, checkTelNotReqd, checkZipCodeIsReqd } from "@/commons/inputCheckCommon";
import * as Yup from "yup";
import moment from "moment";
import { Core as YubinBangoCore } from "yubinbango-core2";
import { useDateForm } from "@/commons/dateForm";
import { UserBaseItem } from "@/modules/userBaseItem";
import { UserBase } from "@/commons/interfaces";

export default defineComponent({
    name: "Profile",
    components: {
        Form,
        Field
    },
    setup() {
        const router = useRouter();
        const route = useRoute();

        const userBaseItem = UserBaseItem.inject();
        const userBase = userBaseItem.userInfo as UserBase; 
        const { image, imageErrorMsgRef, isDeleteRef, fileUploadRef, setImage, operationImage } = inject(ImageItemKey) as ImageItem;
        const { setDate, date, years, months, dates, birthday } = useDateForm();
        const prefectureList = PREFECTURE_LIST;
        const errorMsgRef = ref("");
        const formRef = ref<any>();

        const schema = Yup.object().shape({
            lastName: checkLastNameNotReqd,
            firstName: checkFirstNameNotReqd,
            lastKana: checkLastKanaNotReqd,
            firstKana: checkFirstKanaNotReqd,
            nickname: checkNicknameIsReqd,
            gender: checkGenderIsReqd,
            birthday: checkBirthdayIsReqd,
            isMarried: checkIsMarriedNotReqd,
            hasChild: checkHasChildNotReqd,
            bloodType: checkBloodTypeNotReqd,
            zipCode: checkZipCodeIsReqd,
            prefecture: checkPrefectureIsReqd,
            address: checkAddressNotReqd,
            building: checkBuildingNotReqd,
            tel: checkTelNotReqd
        });

        /**
         * 住所自動入力
         */
        const addressAutoFill = () => {
            const zipCode = userBase.baseInfo.zipCode ? userBase.baseInfo.zipCode : undefined;
            new YubinBangoCore(zipCode, (addr: any)=> {
                userBase.baseInfo.prefecture = addr.region; // 都道府県
                userBase.baseInfo.address = addr.locality; // 市区町村
                userBase.baseInfo.address += addr.street; // 町域
            });
        };

        /**
         * 更新ボタン押下時処理
         */
        const update = () => {
            router.push({ name: "ProfileConfirm" });
        };

        const birthdayValidate = () => {
            formRef.value.validateField("birthday");
        };

        onMounted((): void => {
            // 誕生日をセット
            setDate(userBase.commonAttrInfo.birthday as string);

            userBase.commonAttrInfo.nickName = (typeof(userBase.commonAttrInfo.nickName) === "string") ? userBase.commonAttrInfo.nickName.replaceAll("&lt;","<").replaceAll("&gt;",">") : userBase.commonAttrInfo.nickName;

            if (route.query.errorMsg) {
                errorMsgRef.value = route.query.errorMsg as string;
            }

            watchEffect(() => {
                isDeleteRef.value = image.path ? true : false;

                const tmpDate = moment(`${date.year}-${date.month}-${date.day}`, "YYYY-M-D", true);
                userBase.commonAttrInfo.birthday = tmpDate.isValid() ? tmpDate.format("YYYY-MM-DD") : null;
            });
        });

        return {
            userBase,
            image,
            date,
            birthday,
            years,
            months,
            dates,
            prefectureList,
            fileUploadRef,
            isDeleteRef,
            errorMsgRef,
            imageErrorMsgRef,
            schema,
            formRef,
            setImage,
            operationImage,
            addressAutoFill,
            update,
            birthdayValidate,
            router
        };
    },
});
